export default function MainComponent(props) {
    return (
        <>
            <main id="main" style={props.shouldLoad ? {'minHeight':'200px'} : {'minHeight':'700px'}}>
                {props.children}
            </main>
        </>
    );
}